// #region /snippets/rmit-menu-accordion.liquid
document.addEventListener("DOMContentLoaded", () => {
  const accordions = document.querySelectorAll(".rmit-accordion");

  if (accordions.length > 0) {
    accordions.forEach(bindAccordionBehaviour);
  }
});

const ACCORDION_EXPANDED_VALUE = "true";
const ACCORDION_COLLAPSED_VALUE = "false";
const ACCORDION_LABEL_EXPAND = "Expand";
const ACCORDION_LABEL_COLLAPSE = "Collapse";

function bindAccordionBehaviour(wrapper) {
  const toggle = wrapper.querySelector(".rmit-accordion-toggle");
  const panel = wrapper.querySelector(".rmit-accordion-panel");

  if (!toggle || !panel) {
    return;
  }

  const headerText = toggle.textContent.trim();

  toggle.addEventListener("click", (event) => {
    event.preventDefault();
    toggleExpanded();
  });

  function toggleExpanded () {
    const expanded = wrapper.dataset.expanded !== ACCORDION_EXPANDED_VALUE
    const expandedValue = expanded ? ACCORDION_EXPANDED_VALUE : ACCORDION_COLLAPSED_VALUE;
    wrapper.dataset.expanded = expandedValue;
    toggle.setAttribute("aria-expanded", expandedValue);

    if (headerText) {
      const action = expanded ? ACCORDION_LABEL_COLLAPSE : ACCORDION_LABEL_EXPAND;
      toggle.setAttribute("aria-label", `${action} ${headerText}`);
    }

    panel.hidden = !expanded;
    panel.setAttribute("aria-hidden", expanded ? ACCORDION_COLLAPSED_VALUE : ACCORDION_EXPANDED_VALUE);
  }
}
// #endregion